<template>
  <div
    v-show="!collapsed"
    class="px-3 mt-5 mb-2 text-xs font-semibold tracking-wide uppercase text-slate-500 dark:text-slate-400"
  >
    {{ label }}
  </div>
</template>

<script>
export default {
  props: {
    label: { type: String, required: true },
    collapsed: { type: Boolean, default: false },
  },
}
</script>
